import React from 'react';
import AsyncPage from './async';
import {Navigate, Route} from 'react-router-dom';

export default [
  <Route
    key="/business/products/3d-vto-format"
    path="business/products/3d-vto-format"
    element={<AsyncPage />}
  />,
  <Route
    key="/business/campaign/3d-vto-format"
    path="business/campaign/3d-vto-format"
    element={<Navigate to="../business/products/3d-vto-format" replace />}
  />,
];
